import { TRACKER_TYPES } from '@racemap/utilities/consts/trackers';

/* eslint key-spacing:0 */
function randomTK5000ID(): string {
  return (1000000000 + Math.floor(Math.random() * 999999999 + 1)).toString();
}

function emptyString() {
  return '';
}

export type RaceResultDevices =
  | TRACKER_TYPES.RRDecoder
  | TRACKER_TYPES.RRTrackbox
  | TRACKER_TYPES.RRUbidium;

export const trackerTypes: {
  [key in TRACKER_TYPES]: {
    fixedId: boolean;
    generateAppId: () => string;
    idLength: number;
    requireAPIKey?: boolean;
    isRRDevice?: boolean;
    isInsidersDevice?: boolean;
  };
} = {
  [TRACKER_TYPES.TK5000]: {
    fixedId: false,
    generateAppId: randomTK5000ID,
    idLength: 10,
  },
  [TRACKER_TYPES.Coban]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.TK102]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.CatTrack]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.LK1062G]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 10,
  },
  [TRACKER_TYPES.LK1063G]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 10,
  },
  [TRACKER_TYPES.MiniFinderPicoOrAtto]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.GL300]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.GL300W]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.GL300LTEME]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.GL300LTEMA]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.GL300LTEMG]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.GL310LTEMG]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.GL320LTEMG]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.LiveRank]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.PrimeII]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.Mictrack]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.Teltonika]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 19,
  },
  [TRACKER_TYPES.MT90]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.M20]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
  },
  [TRACKER_TYPES.RMSportTrackerMk0]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 12,
  },
  [TRACKER_TYPES.RacemapTracker]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 12,
  },
  [TRACKER_TYPES.RRDecoder]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
    requireAPIKey: true,
    isRRDevice: true,
  },
  [TRACKER_TYPES.RRTrackbox]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
    requireAPIKey: true,
    isRRDevice: true,
  },
  [TRACKER_TYPES.RRUbidium]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 15,
    requireAPIKey: true,
    isRRDevice: true,
  },
  [TRACKER_TYPES.InsidersInspirit]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 7,
    requireAPIKey: true,
    isInsidersDevice: true,
  },
  [TRACKER_TYPES.InsidersIntense]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 7,
    requireAPIKey: true,
    isInsidersDevice: true,
  },
  [TRACKER_TYPES.InsidersSimulator]: {
    fixedId: true,
    generateAppId: emptyString,
    idLength: 7,
    requireAPIKey: true,
    isInsidersDevice: true,
  },
};

export default trackerTypes;
